import { Editor, Element, Transforms } from "slate";
export var unwrapLink = function (editor) {
    Transforms.unwrapNodes(editor, {
        match: function (n) {
            return !Editor.isEditor(n) && Element.isElement(n) && n.type === "link";
        },
    });
};
